import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './apps/eval/components/HomePage';
import ShippingApp from './apps/shipping/ShippingApp';
import EvalApp from './apps/eval/EvalApp';
import AgentBench from './apps/agentbench/AgentBench';
import ArenaLanding from './apps/agentbench/ArenaLanding';
import AgentAuth from './apps/agentbench/AgentAuth';
import Leaderboard from './apps/agentbench/Leaderboard';
import { AgentProvider } from './apps/agentbench/AgentContext';
import { ThemeProvider } from './apps/agentbench/ThemeContext';
import ProtectedRoute from './apps/agentbench/ProtectedRoute';
import Disclaimer from './apps/agentbench/Disclaimer';
import AgentDashboard from './apps/agentbench/AgentDashboard';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
      <AgentProvider>
        <Routes>
          <Route path="/" element={<ArenaLanding />} />
          <Route path="/arena" element={<ArenaLanding />} />
          <Route path="/arena/auth" element={<AgentAuth />} />
          <Route path="/arena/leaderboard" element={<Leaderboard />} />
          <Route path="/agent-bench" element={<ProtectedRoute><AgentBench /></ProtectedRoute>} />
          <Route path="/arena/disclaimer" element={<Disclaimer />} />
          <Route path="/arena/my-runs" element={<AgentDashboard />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/shipping" element={<ShippingApp />} />
          <Route path="/eval" element={<EvalApp />} />
          <Route path="*" element={<ArenaLanding />} />
        </Routes>
      </AgentProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
